/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createProductsPageSummaryFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ProductsPageSummary } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/products/summary
 */
export interface SummaryRequestBuilder extends BaseRequestBuilder<SummaryRequestBuilder> {
    /**
     * The figures in the metric row above the product list: how many products there are, active and inactive (a product without an active flag counts as active, as it does in the catalog); active products with no image; active products with nothing on hand, and how many of the top sellers (up to 100, by units in the last 90 days) are among them — both null when no active product has stock, since then the organization isn't tracking inventory; and the best seller by units in the last 30 days. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ProductsPageSummary>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ProductsPageSummary | undefined>;
    /**
     * The figures in the metric row above the product list: how many products there are, active and inactive (a product without an active flag counts as active, as it does in the catalog); active products with no image; active products with nothing on hand, and how many of the top sellers (up to 100, by units in the last 90 days) are among them — both null when no active product has stock, since then the organization isn't tracking inventory; and the best seller by units in the last 30 days. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SummaryRequestBuilderUriTemplate = "{+baseurl}/api/analytics/products/summary";
/**
 * Metadata for all the requests in the request builder.
 */
export const SummaryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SummaryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createProductsPageSummaryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
